import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class BreadcrumbService {
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';

  constructor() { }

  public breadcrumbs = new BehaviorSubject<any>({});
  public breadcrumbs$ = this.breadcrumbs.asObservable();

  // if dynamic breadcrumbs have been set for the url, then get them,
  // otherwise get the static one on the route definition (in activatedRoute)
  getBreadcrumbs(url: string, activatedRoute: ActivatedRoute | null = null): MenuItem[] {
    if (this.breadcrumbs.getValue()[url]) {
      return this.breadcrumbs.getValue()[url];
    } else if (activatedRoute) {
      const staticLabel = activatedRoute.snapshot.data[BreadcrumbService.ROUTE_DATA_BREADCRUMB];
      if (staticLabel) {
        return [{label: staticLabel, routerLink: url}];
      }
    }
    return [];
  }

  /**
   * Use this to set custom breadcrumbs, for example when info (like an identifier) from the server is needed...
   * or if more than one breadcrumb is needed for one child route,
   * otherwise the {data: breadcrumb: <label>}} on the route will be used by default
   *
   * @param url: current url path for which we want to set custom breadcrumb(s)
   * @param breadcrumbs: list of MenuItem objects with {label: label, routerLink: url to go to for the link}
   */
  setBreadcrumbs(url: string, breadcrumbs: MenuItem[]) {
    const breadcrumbsMap = this.breadcrumbs.getValue();
    breadcrumbsMap[url] = breadcrumbs;
    this.breadcrumbs.next(breadcrumbsMap);
  }
}
